import React from "react";
import { Outlet } from "react-router-dom";
import HeaderBottom from "./header-bottom";
import HeaderTop from "./header-top";
import Copyright from "./copyright";
import { Styled } from "./styles";
import { Modal as FormsModal } from "@dippi/forms";
import useURLIdChecker from "@/hooks/misc/useURLChecker";

const Layout: React.FC = () => {
    useURLIdChecker();

    return (
        <React.Fragment>
            <Styled.Header>
                <HeaderTop />
                <HeaderBottom />
            </Styled.Header>
            <Styled.Main>
                <Outlet />
                <Copyright />
            </Styled.Main>
            <FormsModal />
        </React.Fragment>
    );
};

export default Layout;
